function isFieldFixed(field) {
  const fixed = field?.fixed_value != null ? String(field.fixed_value).trim() : "";
  return Boolean(fixed) && field?.collect_in_chat === false;
}

export function normalizePdfTemplateAnalyzeConfig(res) {
  const payload =
    res?.data && typeof res.data === "object" && !Array.isArray(res.data) ? res.data : res;
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) return null;

  const cfg =
    payload.config && typeof payload.config === "object" && !Array.isArray(payload.config)
      ? { ...payload.config }
      : { ...payload };

  if (Array.isArray(payload.fields_schema)) cfg.fields_schema = payload.fields_schema;
  if (Array.isArray(payload.placeholder_positions)) cfg.placeholder_positions = payload.placeholder_positions;
  if (payload.document_blueprint && typeof payload.document_blueprint === "object") {
    cfg.document_blueprint = payload.document_blueprint;
  }
  if (Array.isArray(payload.refinement_history)) cfg.refinement_history = payload.refinement_history;
  if (payload.analyzed_at) cfg.analyzed_at = payload.analyzed_at;
  if (payload.analyze_mode) cfg.analyze_mode = payload.analyze_mode;
  if (payload.analyze_status) cfg.analyze_status = payload.analyze_status;
  if (payload.template_quality) cfg.template_quality = payload.template_quality;
  if (payload.generation_mode_hint) cfg.generation_mode_hint = payload.generation_mode_hint;
  if (payload.fill_coverage_ratio != null) cfg.fill_coverage_ratio = payload.fill_coverage_ratio;
  if (payload.fillable_field_count != null) cfg.fillable_field_count = payload.fillable_field_count;
  if (payload.positioned_count != null) cfg.positioned_count = payload.positioned_count;
  if (Array.isArray(payload.missing_position_keys)) cfg.missing_position_keys = payload.missing_position_keys;
  if (Array.isArray(payload.rejected_field_keys)) cfg.rejected_field_keys = payload.rejected_field_keys;
  if (payload.template_document_id && !cfg.template_document_id) {
    cfg.template_document_id = payload.template_document_id;
  }

  if (!Array.isArray(cfg.fields_schema) || cfg.fields_schema.length === 0) return null;
  return cfg;
}

export function getRefinementSummaryFromResponse(res, prevFields = []) {
  const payload =
    res?.data && typeof res.data === "object" && !Array.isArray(res.data) ? res.data : res;
  if (payload?.refinement_summary && typeof payload.refinement_summary === "object") {
    return {
      ...payload.refinement_summary,
      intent_summary:
        payload.refinement_summary.intent_summary || payload.intent_summary || null,
    };
  }
  if (typeof payload?.intent_summary === "string" && payload.intent_summary.trim()) {
    return { intent_summary: payload.intent_summary.trim() };
  }

  const cfg = normalizePdfTemplateAnalyzeConfig(res);
  const after = cfg?.fields_schema || [];
  const before = Array.isArray(prevFields) ? prevFields : [];
  const beforeByKey = new Map(before.map((f) => [f.key, f]));

  let added = 0;
  let removed = 0;
  let newlyFixed = 0;

  for (const f of after) {
    if (!beforeByKey.has(f.key)) added += 1;
    else if (isFieldFixed(f) && !isFieldFixed(beforeByKey.get(f.key))) newlyFixed += 1;
  }
  for (const f of before) {
    if (!after.some((a) => a.key === f.key)) removed += 1;
  }

  return {
    total: after.length,
    chatCount: after.filter((f) => !isFieldFixed(f)).length,
    fixedCount: after.filter(isFieldFixed).length,
    added,
    removed,
    newlyFixed,
  };
}

export function buildRefineDetailLines(summary, t) {
  if (!summary || typeof summary !== "object") return [];
  const lines = [];
  const intent = String(summary.intent_summary || "").trim();
  if (intent) {
    lines.push(t("agentsListPage.pdfTemplateRefineIntentLabel", { intent }));
  }
  if (summary.total != null) {
    lines.push(
      t("agentsListPage.pdfTemplateRefineSummaryDetail", {
        total: summary.total ?? 0,
        chatCount: summary.chatCount ?? 0,
        fixedCount: summary.fixedCount ?? 0,
      })
    );
  }
  if (summary.newlyFixed > 0) {
    lines.push(t("agentsListPage.pdfTemplateRefineSummaryNewlyFixed", { count: summary.newlyFixed }));
  }
  if (summary.added > 0) {
    lines.push(t("agentsListPage.pdfTemplateRefineSummaryAdded", { count: summary.added }));
  }
  if (summary.removed > 0) {
    lines.push(t("agentsListPage.pdfTemplateRefineSummaryRemoved", { count: summary.removed }));
  }
  return lines;
}
